// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: BJWBeVtSnwB0
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import Sidebar from "../../Sidebar"; // plasmic-import: NdFBK2CrJIH5/component
import TopBar from "../../TopBar"; // plasmic-import: 0Oim0KTDv11d/component
import ClientPaymentsCard from "../../ClientPaymentsCard"; // plasmic-import: 4h-isvtBnlNT/component
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicClientInstance.module.css"; // plasmic-import: BJWBeVtSnwB0/css

createPlasmicElementProxy;

export const PlasmicClientInstance__VariantProps = new Array();

export const PlasmicClientInstance__ArgProps = new Array(
  "debtorName",
  "debtorContact",
  "amount",
  "dateCreated",
  "emailsSent",
  "phoneCallsMade"
);

const $$ = {};

function PlasmicClientInstance__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <Sidebar
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}
            className={classNames("__wab_instance", sty.sidebar)}
          />

          <div className={classNames(projectcss.all, sty.freeBox__tcKWn)}>
            <TopBar
              data-plasmic-name={"topBar"}
              data-plasmic-override={overrides.topBar}
              className={classNames("__wab_instance", sty.topBar)}
              userNameText={"Jones Ferdinand"}
            />

            <div
              data-plasmic-name={"vertStack"}
              data-plasmic-override={overrides.vertStack}
              className={classNames(projectcss.all, sty.vertStack)}
            >
              <Stack__
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__n83Ph)}
              >
                <div
                  data-plasmic-name={"title"}
                  data-plasmic-override={overrides.title}
                  className={classNames(projectcss.all, sty.title)}
                >
                  {renderPlasmicSlot({
                    defaultContents: "Nike",
                    value: args.debtorName,
                    className: classNames(sty.slotTargetDebtorName)
                  })}
                </div>
                <div
                  data-plasmic-name={"title2"}
                  data-plasmic-override={overrides.title2}
                  className={classNames(projectcss.all, sty.title2)}
                >
                  {renderPlasmicSlot({
                    defaultContents: "john@nike.com",
                    value: args.debtorContact,
                    className: classNames(sty.slotTargetDebtorContact)
                  })}
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__oeb5T
                  )}
                >
                  {"Total Collected:"}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__cxpmu)}>
                  {renderPlasmicSlot({
                    defaultContents: "$1040.00",
                    value: args.amount,
                    className: classNames(sty.slotTargetAmount)
                  })}
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__et0Xm
                  )}
                >
                  {"Emails/Texts Sent:"}
                </div>
                {renderPlasmicSlot({
                  defaultContents: "0",
                  value: args.emailsSent,
                  className: classNames(sty.slotTargetEmailsSent)
                })}
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__dy8YB
                  )}
                >
                  {"Phone Calls Made:"}
                </div>
                {renderPlasmicSlot({
                  defaultContents: "0",
                  value: args.phoneCallsMade,
                  className: classNames(sty.slotTargetPhoneCallsMade)
                })}
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__mizI
                  )}
                >
                  {"Created:"}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__isqqr)}>
                  {renderPlasmicSlot({
                    defaultContents: "Dec. 28th, 12:25 AM",
                    value: args.dateCreated,
                    className: classNames(sty.slotTargetDateCreated)
                  })}
                </div>
                <div
                  data-plasmic-name={"viewInfo"}
                  data-plasmic-override={overrides.viewInfo}
                  className={classNames(projectcss.all, sty.viewInfo)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___5SsTw
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "medium")
                      ? "View or Edit Debtor Info"
                      : "View or Edit Debtor Info"}
                  </div>
                </div>
              </Stack__>
              <div className={classNames(projectcss.all, sty.freeBox___75R8X)}>
                <div
                  data-plasmic-name={"title9"}
                  data-plasmic-override={overrides.title9}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title9
                  )}
                >
                  {"Notes"}
                </div>
                <div
                  data-plasmic-name={"rectangle50"}
                  data-plasmic-override={overrides.rectangle50}
                  className={classNames(projectcss.all, sty.rectangle50)}
                >
                  <textarea
                    data-plasmic-name={"paymentNotes"}
                    data-plasmic-override={overrides.paymentNotes}
                    className={classNames(
                      projectcss.all,
                      projectcss.textarea,
                      sty.paymentNotes
                    )}
                    ref={ref => {
                      $refs["paymentNotes"] = ref;
                    }}
                    value={"This is a text area."}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__wuy5)}>
                  <div
                    data-plasmic-name={"title12"}
                    data-plasmic-override={overrides.title12}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title12
                    )}
                  >
                    {"Payments"}
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__jdrMn)}>
                  <div
                    data-plasmic-name={"title13"}
                    data-plasmic-override={overrides.title13}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title13
                    )}
                  >
                    {"Amount"}
                  </div>
                  <div
                    data-plasmic-name={"title14"}
                    data-plasmic-override={overrides.title14}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title14
                    )}
                  >
                    {"Status"}
                  </div>
                  <div
                    data-plasmic-name={"title15"}
                    data-plasmic-override={overrides.title15}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title15
                    )}
                  >
                    {"Type"}
                  </div>
                  <div
                    data-plasmic-name={"title16"}
                    data-plasmic-override={overrides.title16}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title16
                    )}
                  >
                    {"Date"}
                  </div>
                </div>
                <Stack__
                  as={"div"}
                  data-plasmic-name={"paymentsStack"}
                  data-plasmic-override={overrides.paymentsStack}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.paymentsStack)}
                >
                  <ClientPaymentsCard
                    className={classNames(
                      "__wab_instance",
                      sty.clientPaymentsCard__qOn1S
                    )}
                    paymentDate={
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text___3Xe5Y
                        )}
                      >
                        {"Nov 25th, 2023"}
                      </div>
                    }
                  />

                  <ClientPaymentsCard
                    className={classNames(
                      "__wab_instance",
                      sty.clientPaymentsCard__x0QZc
                    )}
                  />
                </Stack__>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "sidebar",
    "topBar",
    "vertStack",
    "title",
    "title2",
    "viewInfo",
    "title9",
    "rectangle50",
    "paymentNotes",
    "title12",
    "title13",
    "title14",
    "title15",
    "title16",
    "paymentsStack"
  ],

  sidebar: ["sidebar"],
  topBar: ["topBar"],
  vertStack: [
    "vertStack",
    "title",
    "title2",
    "viewInfo",
    "title9",
    "rectangle50",
    "paymentNotes",
    "title12",
    "title13",
    "title14",
    "title15",
    "title16",
    "paymentsStack"
  ],

  title: ["title"],
  title2: ["title2"],
  viewInfo: ["viewInfo"],
  title9: ["title9"],
  rectangle50: ["rectangle50", "paymentNotes"],
  paymentNotes: ["paymentNotes"],
  title12: ["title12"],
  title13: ["title13"],
  title14: ["title14"],
  title15: ["title15"],
  title16: ["title16"],
  paymentsStack: ["paymentsStack"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicClientInstance__ArgProps,
          internalVariantPropNames: PlasmicClientInstance__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicClientInstance__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicClientInstance";
  } else {
    func.displayName = `PlasmicClientInstance.${nodeName}`;
  }
  return func;
}

export const PlasmicClientInstance = Object.assign(
  // Top-level PlasmicClientInstance renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    topBar: makeNodeComponent("topBar"),
    vertStack: makeNodeComponent("vertStack"),
    title: makeNodeComponent("title"),
    title2: makeNodeComponent("title2"),
    viewInfo: makeNodeComponent("viewInfo"),
    title9: makeNodeComponent("title9"),
    rectangle50: makeNodeComponent("rectangle50"),
    paymentNotes: makeNodeComponent("paymentNotes"),
    title12: makeNodeComponent("title12"),
    title13: makeNodeComponent("title13"),
    title14: makeNodeComponent("title14"),
    title15: makeNodeComponent("title15"),
    title16: makeNodeComponent("title16"),
    paymentsStack: makeNodeComponent("paymentsStack"),
    // Metadata about props expected for PlasmicClientInstance
    internalVariantProps: PlasmicClientInstance__VariantProps,
    internalArgProps: PlasmicClientInstance__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicClientInstance;
/* prettier-ignore-end */
